import type { TValidatorValue } from './models';
import { validateNotEmpty } from './not-empty';
import { composeValidators } from './utils';

export const CONTROL_NUMBER_ERROR = 'Неправильное контрольное число';
export const LENGTH_ERROR = 'ИНН состоит из 10 или 12 цифр';
export const ONLY_NUMBERS_ERROR = 'ИНН состоит только из цифр';
export const START_CHARS_ERROR = 'ИНН не должен начинаться с 9909';

const checkDigit = (inn: string, coefficients: number[]) => {
    let n = 0;

    for (let i = 0; i < coefficients.length; i++) {
        n += coefficients[i] * parseInt(inn[i], 10);
    }

    return (n % 11) % 10;
};

// http://confluence.moscow.alfaintra.net/pages/viewpage.action?pageId=39388355
export const isValidInn = (value: TValidatorValue = '') => {
    if (/\D/.test(value)) {
        return ONLY_NUMBERS_ERROR;
    }

    const { length } = value;

    // Полнота формата 10 или 12 символов
    if (length !== 10 && length !== 12) {
        return LENGTH_ERROR;
    }

    // ИНН не должен начинаться с 9909.
    if (value.substr(0, 4) === '9909') {
        return START_CHARS_ERROR;
    }

    // Проверка контрольной суммы для 10-значного ИНН
    if (length === 10) {
        const n10 = checkDigit(value, [2, 4, 10, 3, 5, 9, 4, 6, 8]);

        if (n10 !== parseInt(value[9], 10)) {
            return CONTROL_NUMBER_ERROR;
        }
    }

    // Проверка контрольной суммы для 12-значного ИНН
    if (length === 12) {
        const n11 = checkDigit(value, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
        const n12 = checkDigit(value, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);

        if (n11 !== parseInt(value[10], 10) || n12 !== parseInt(value[11], 10)) {
            return CONTROL_NUMBER_ERROR;
        }
    }

    return undefined;
};

export const validateInn = () => composeValidators(validateNotEmpty(), isValidInn);
